import * as React from "react"
import { useState } from "react"
import { PaginationType } from "@/types"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, Link, redirect } from "@tanstack/react-router"
import { useReactToPrint } from "react-to-print"

import { EmailTemplatedMessagesType } from "@/types/templated-messages"
import { canViewThisPage } from "@/lib/api/auth"
import { getEmailTemplatedMessages } from "@/lib/api/templated-messages"
import { Button } from "@/components/ui/button"
import { DataTable } from "@/components/data-table"
import { Header } from "@/components/header"
import { Icons } from "@/components/icons"
import { emailTemplatedMessagesColumns } from "@/components/table/columns/email-columns"
import { ExportOperationModal } from "@/components/table/operations/export-operations"

import AddEmailTemplatedMessagesPage from "./add"

export const Route = createFileRoute("/_home/message-templates/email/")({
  beforeLoad: () => {
    if (canViewThisPage("himo_billing.view_emailtemplatedmessage")) {
      return
    }

    return redirect({ to: "/access-denied" })
  },
  component: EmailTemplatedMessagePage,
})

function EmailTemplatedMessagePage() {
  const [showExportModal, setShowExportModal] = React.useState<boolean>(false)
  const [search, setSearch] = useState<string>("")
  const [zones, setZones] = React.useState<number[]>([])
  /*const [books, setBooks] = React.useState<number[]>([]); */
  const [defaultPage, setDefaultPage] = useState<number>(10)
  const [page, setPage] = useState<number>(1)

  const [nextPageUrl, setNextPageUrl] = React.useState<string | null>(null)
  const [prevPageUrl, setPrevPageUrl] = React.useState<string | null>(null)

  const {
    data: emailTemplatedMessages,
    isError,
    isLoading,
  } = useQuery<PaginationType<EmailTemplatedMessagesType>>({
    queryKey: ["emailTemplatedMessages", defaultPage, page, search, zones],
    queryFn: () => getEmailTemplatedMessages(defaultPage, page, search, zones),
  })

  React.useEffect(() => {
    if (emailTemplatedMessages) {
      setNextPageUrl(emailTemplatedMessages.next)
      setPrevPageUrl(emailTemplatedMessages.previous)
    }
  }, [emailTemplatedMessages])

  const contentRef = React.useRef<HTMLDivElement>(null)
  const reactToPrintFn = useReactToPrint({ contentRef })

  return (
    <main className="space-y-4 p-4">
      <Header>Email Templated Messages</Header>
      <div ref={contentRef} className="print:p-2">
        <DataTable
          columns={emailTemplatedMessagesColumns}
          data={emailTemplatedMessages?.results ?? []}
          search={{
            //field: "zone",
            label: "zone",
            value: search,
            onChange: setSearch,
          }}
          isLoading={isLoading}
          isError={isError}
          defaultPage={defaultPage}
          setDefaultPage={setDefaultPage}
          nextPageUrl={nextPageUrl}
          prevPageUrl={prevPageUrl}
          page={page}
          setPage={setPage}
          totalCount={emailTemplatedMessages?.count}
          zones={zones}
          setZones={setZones}
        >
          {/*  <div className="flex w-full justify-end">
          <Link
            to="/message-templates/email/add"
            className={buttonVariants({ variant: "default" })}
          >
            <Icons.add className="size-4" /> Add Email Templated Message
          </Link>
        </div> */}
          <div className="flex w-full justify-end">
            <AddEmailTemplatedMessagesPage />
          </div>
          <Button onClick={() => reactToPrintFn()}>
            <Icons.download />
            Print Email Templated Message
          </Button>
          <ExportOperationModal
            tableData={emailTemplatedMessages?.results ?? [{}]}
            fileName="Email Templated Message"
            showExportModal={showExportModal}
            setShowExportModal={setShowExportModal}
          />
        </DataTable>
      </div>
    </main>
  )
}
